import * as React from 'react';
import {darken, lighten, alpha} from "@mui/material";
import { createRoot } from 'react-dom/client';
import Stack from '@mui/material/Stack';
import LinearProgress, { linearProgressClasses } from '@mui/material/LinearProgress';
import Typography from '@mui/material/Typography';
import Tooltip from '@mui/material/Tooltip';
import IconButton from '@mui/material/IconButton';
import Bs4MainDispatch from '../Bs4MainDispatch';
import { colorIsDark } from '../Bs4Components/Bs4Utils';
import Bs4ViewAvatar from '../Bs4Components/Bs4ViewAvatar';

const  AVATAR = 'avatar';
const BS4_PROGRESS = 'bs4Progress';

export const formatterJSON = (cell, formatterParams, onRendered) => {
  const value = cell.getValue();  
  const div = document.createElement("div");  
  const root = createRoot(div);  

  onRendered(() => {
    root.render(
      <Bs4JSON value={value} cell={cell} formatterParams={formatterParams}/>        
    )
  })

  return div;
}

const Bs4JSON = (props) => {
  const values = React.useMemo(() => {    
    if (!Array.isArray(props.value)) return [];
    // return [...props.value, ...props.value, ...props.value, ...props.value, ...props.value, ...props.value].reverse();
    return props.value.reverse();
  }, [props.value]);

  React.useEffect(() => {
    if (props.cell?.getRow()) props.cell.getRow().normalizeHeight();
  }, [props.cell]);

  return (
    <Stack 
      direction="row-reverse" 
      spacing={0} 
      sx={{
        justifyContent: "flex-end",
        alignItems: "flex-start",
        flexWrap: 'wrap-reverse',
        paddingLeft: '10px',
        paddingTop: '10px',
      }}
    >
      {values.map((value, index) => {
        switch(value.type) {
          case AVATAR: return <Bs4Avatar key={index} value={value} formatterParams={props.formatterParams} cell={props.cell}/>;
          case BS4_PROGRESS: return <Bs4Progress key={index} value={value} formatterParams={props.formatterParams} cell={props.cell}/>;
          default: 
            console.log('...???...JSON type', value, index, values);
            return <span key={index}>{value.type+'???'}</span>;
        }  
      })}
     
    </Stack>
  )
}

const Bs4Avatar = (props) => {  
  const handleClick = (event) => {
    // prośba aby po kliknięciu w avatar w kolumnie (type=avatar)
    // wywoływać request do serwera bs4ColumnClick
    // przekazać do tego requestu (poza innymi typowymi danymi):
    // addOptIds - wartość z atrybutu rowId z danych json
    // targetObject -id wiersza, w którym kliknięto
    // colId - id kolumny    
    const bs4Report = props.formatterParams.bs4Report;    
    const id = props.cell?.getRow()?.getData()?.id;
    Bs4MainDispatch.commandParser('Bs4ColumnClick',{ addOptIds: props.value?.rowId, targetObject: id, currFormId: bs4Report.formId }, bs4Report.bs4KartotekaId);
  }  

  return (
    <Tooltip title={<Typography>{props.value.label}</Typography>} placement='top' arrow>
      <IconButton size='small' onClick={handleClick} sx={{marginLeft: '-10px', marginTop: '-10px', padding: '2px'}}>
        <Bs4ViewAvatar 
          fileId={props.value.fileId} 
          initials={props.value.initials} 
          label={props.value.label} 
          circleColor={props.value.circleColor} 
          size={32} 
          sx={{
            borderColor: '#ffffff',
            border: 'solid 2px #ffffff'
          }}
        />
      </IconButton>
    </Tooltip>
  )
}

const Bs4Progress = (props) => {  
  const [colorR, colorL] = React.useMemo(() => {
    let color = props.value.barColor
    const luminance = colorIsDark(color);
    let fR = luminance / 10;
    let fL = 0.7;    
    return [darken(color, fR), lighten(color, fL)]    
  }, [props.value.barColor]);

  return (
    <Tooltip title={<Typography>{props.value.label}</Typography>} placement='top' arrow>
      <Stack direction='row' sx={{ justifyContent: "flex-start", alignItems: "center", height: '100%', width: '100%'}}>
        <LinearProgress 
          variant="determinate" 
          value={props.value?.value} 
          sx={{
            marginLeft: '-10px', 
            marginTop: '-10px',
            height: 10,
            width: 100,
            borderRadius: 99,
            [`&.${linearProgressClasses.colorPrimary}`]: {
              backgroundColor: colorL,
            },
            [`& .${linearProgressClasses.bar}`]: {
              borderRadius: 99,
              backgroundColor: colorR,
            },
          }}
        />
        <span style={{visibility: 'hidden'}}>.</span>
      </Stack>
    </Tooltip>
  )
}